import type { CSSProperties } from 'react';
import type { TextStyleFields } from '@/types/blocks';

const WEIGHT_MAP: Record<Exclude<TextStyleFields['fontWeight'], 'inherit'>, number> = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

/**
 * Sobrescritas de cor/tamanho/peso de um bloco — só inclui as chaves que têm
 * valor definido, para não sobrescrever com `undefined` o estilo de base
 * (herdado do tema/aparência) ao fazer `{...baseStyle, ...getTextStyle(block)}`.
 *
 * `includeColor: false` (usado na edição inline do canvas) omite a cor —
 * uma cor customizada perto do fundo do editor (ex.: branco) deixaria o
 * texto ilegível justamente enquanto se digita. Tamanho/peso continuam
 * refletidos; a cor real só aparece no preview estático (bloco não selecionado)
 * e no site público.
 */
export function getTextStyle(block: TextStyleFields, options: { includeColor?: boolean } = {}): CSSProperties {
  const { includeColor = true } = options;
  const style: CSSProperties = {};
  if (includeColor && block.color) style.color = block.color;
  if (block.fontSize > 0) style.fontSize = `${block.fontSize}px`;
  if (block.fontWeight !== 'inherit') style.fontWeight = WEIGHT_MAP[block.fontWeight];
  return style;
}
